import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getReportNames } from "@tKgpco/Services/PowerBiService";

interface LoadPowerBIReportParameter {
    onError?: (message: string) => void;
    onSuccess?: (result: string[]) => void;
}

interface LoadPowerBIReportResult {
    result: string[];
}

type HandlerType = Handler<LoadPowerBIReportParameter, LoadPowerBIReportResult>;

export const RequestPowerBIReportFromApi: HandlerType = async props => {
    const result = await getReportNames();

    if (result.length) {
        props.result = result;
        props.parameter?.onSuccess?.(result);
    } else {
        props.parameter?.onError?.("No Result Found");
        return false;
    }
};

export const chain = [RequestPowerBIReportFromApi];
const getPowerBIReportNames = createHandlerChainRunner(chain, "getPowerBIReportNames");
export default getPowerBIReportNames;
